import { apiService } from '../services/api';
import { prepareImageDataUrl } from './imageUpload';
import { uploadOptimizedImage } from './tenantMediaUpload';

/** Upload assignment attachment to tenant media when available; otherwise inline preview. */
export async function resolveAssignmentAttachmentUrl(
  file: File,
  ownerId?: string
): Promise<string> {
  const id = ownerId ?? crypto.randomUUID();
  try {
    const uploaded = await uploadOptimizedImage(file, {
      ownerType: 'assignment',
      ownerId: id,
    });
    if (uploaded?.previewUrl) {
      return uploaded.previewUrl;
    }
    if (uploaded?.mediaId) {
      try {
        const urlRes = await apiService.getMediaUrl(String(uploaded.mediaId));
        if (urlRes.data?.url?.trim()) return urlRes.data.url.trim();
      } catch {
        /* use media id reference if URL fetch fails */
      }
      return String(uploaded.mediaId);
    }
  } catch {
    /* fall through to inline preview */
  }
  return prepareImageDataUrl(file);
}

export function isDisplayableImageUrl(url: string): boolean {
  const value = url.trim();
  return (
    value.startsWith('data:image/') ||
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('/')
  );
}
